import { render, staticRenderFns } from "./learningModule.vue?vue&type=template&id=57bac3a2&scoped=true"
import script from "./learningModule.vue?vue&type=script&lang=js"
export * from "./learningModule.vue?vue&type=script&lang=js"
import style0 from "./learningModule.vue?vue&type=style&index=0&id=57bac3a2&prod&lang=scss&scoped=true"
import style1 from "./learningModule.vue?vue&type=style&index=1&id=57bac3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bac3a2",
  null
  
)

export default component.exports